import { html } from "../../helpers/html-template.js";
import { guideIconHtml } from "@scalar-org/guide-icons";
import { EditorClasses } from "../../styles.js";
import { toVueComponent } from "@scalar-org/vue-render";
function buttonTemplate(iconHtml, props) {
  const tag = props.isEditable ? "button" : "a";
  return html`
    <${tag} class="${EditorClasses.Button}" href="${props.href}" rel="noopener noreferrer" target="_blank">
      ${iconHtml}
      ${props.title}
      <ssg-children></ssg-children>
    </${tag}>
  `;
}
async function guideButtonHtml(props) {
  const icon = await guideIconHtml({ src: props.icon, title: "link icon" });
  return buttonTemplate(icon, props);
}
const ScalarButtonVue = toVueComponent(
  /** Synchronous render function for the Vue component that uses slots for the icon */
  (props) => buttonTemplate('<ssg-children name="icon"></ssg-children>', props),
  {
    href: String,
    title: String,
    icon: String,
    isEditable: Boolean
  }
);
export {
  ScalarButtonVue,
  guideButtonHtml
};
//# sourceMappingURL=component.js.map
